<template>
    <v-container fluid fill-height>
        <v-layout row wrap>
            <v-flex xs12>
                <v-toolbar color="#eee" class="elevation-0 secondary--text" style="background: transparent">
                    <v-toolbar-title>Faturamento com empresas</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex xs4>
                <div class="text-xs-center pt-3">
                <v-date-picker v-model="picker" type="month" locale="pt-br" color="info" style="height: 33em;">
                    <v-layout column  style="height: 6em;">
                        <v-btn
                            block
                            flat
                            color="green"
                            :loading="loading"
                            @click="pegarFaturas"
                            :disabled="!picker"
                        >
                            CARREGAR FATURAMENTOS
                        </v-btn>
                    </v-layout>
                </v-date-picker>
                </div>
            </v-flex>
            <v-flex xs8>
                <v-layout
                    align-center
                    justify-center
                    class="headline grey--text text--darken-2"
                >
                    <v-spacer></v-spacer>
                    Selecione um mês para ver os faturamentos
                    <v-spacer></v-spacer>
                    <v-menu offset-y bottom>
                        <v-btn icon slot="activator">
                            <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-list dense class="pa-0">
                            <template v-for="(filtro, index) in filters">
                                <v-list-tile :key="index" ripple @click="selected_filter = filtro.value">
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="filtro.text" class="text-xs-center"></v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-menu>
                </v-layout>
                <div class="pt-3">
                <v-list>
                    <v-list-tile v-if="!faturamentos.length">
                        <v-list-tile-content>
                            <v-list-tile-title
                            class="text-xs-center title font-weight-light"
                            >Sem faturamentos carregados :(</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <template v-else>
                        <v-list-tile v-for="(faturamento, index) in faturamentos" :key="index" icon>
                            <v-list-tile-avatar icon>
                                <v-icon color="green" v-if="faturamento.posto">local_gas_station</v-icon>
                                <v-icon color="green" v-else>ac_unit</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title v-html="faturamento.empresa"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="`Valor: R$ ${faturamento.valor_faturamento}`"></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-list-tile-action-text
                                    v-html="`Data da Fatura: ${faturamento.data_fatura.split('-').reverse().join('/')}`"
                                />
                                <v-list-tile-action-text
                                    v-if="faturamento.fatura_paga"
                                    v-html="`Data do Pagamento: ${faturamento.data_hora_pagamento.substr(0, 10).split('-').reverse().join('/')}`"
                                />
                            </v-list-tile-action>
                            <v-list-tile-action>
                              <v-tooltip top lazy>
                                  <v-btn icon slot="activator" @click="TelaBloqueio(faturamento)">
                                      <v-icon color="error">block</v-icon>
                                  </v-btn>
                                  Bloquear Empresa
                                </v-tooltip>
                            </v-list-tile-action>
                            <v-list-tile-action>
                                <v-tooltip lazy bottom>
                                    <v-btn icon slot="activator" @click="visualizarFatura(faturamento)">
                                        <v-icon color="info">
                                            remove_red_eye
                                        </v-icon>
                                    </v-btn>
                                    Detalhes
                                </v-tooltip>
                            </v-list-tile-action>
                            <v-list-tile-action>
                                <v-tooltip top lazy>
                                    <v-btn icon slot="activator" @click="visualizarAnexo(faturamento)">
                                    <v-icon color="secondary">receipt</v-icon>
                                    </v-btn>Visualizar comprovante
                                </v-tooltip>
                            </v-list-tile-action>
                            <v-list-tile-action v-if="faturamento.fatura_paga === false">
                            <v-tooltip top lazy>
                                <v-btn icon slot="activator" @click="selecionarFatura(faturamento)">
                                    <v-icon color="green">check_circle</v-icon>
                                </v-btn>
                                Confirmar Recebimento
                            </v-tooltip>
                            </v-list-tile-action>
                            <v-list-tile-action v-else>
                                <v-tooltip top lazy>
                                    <v-btn icon slot="activator" @click="selecionarFaturaCancelamento(faturamento)">
                                        <v-icon color="red">cancel</v-icon>
                                    </v-btn>
                                    Cancelar Recebimento
                                </v-tooltip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                </v-list>
                </div>
            </v-flex>
            <v-dialog v-model="dialog_confirmacao" width="400">
              <v-card>
                <v-card-text
                  class="text-xs-center headline primary--text"
                >Confirme o recebimento da fatura para a empresa {{fatura_selecionada.empresa}}</v-card-text>
                <v-card-text class="text-xs-center">
                  <v-menu>
                    <v-text-field
                      slot="activator"
                      readonly
                      label="Data do Pagamento"
                      outline
                      hide-details
                      :value="selected_date ? selected_date.split('-').reverse().join('/') : ''"
                    ></v-text-field>
                    <v-date-picker color="info" v-model="selected_date" locale="pt-br"></v-date-picker>
                  </v-menu>
                </v-card-text>
                <v-card-actions>
                  <v-btn block flat color="grey darken-3" @click="fecharConfirmacao()">VOLTAR</v-btn>
                  <v-btn block flat color="green" :disabled="!selected_date" @click="confirmarPagamento()" >CONFIRMAR</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-if="visualizarComprovante" v-model="visualizarComprovante" width="620">
              <v-card class="pa-0">
                  <v-toolbar color="primary">
                      <v-btn icon @click="fechar"><v-icon color="white">close</v-icon></v-btn>
                      <v-spacer></v-spacer>
                      <v-toolbar-title style="color: white;">Visualizar comprovante</v-toolbar-title>
                      <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout column class="pa-0 ma-0">
                      <v-flex align-self-center class="pa-0 ma-0">
                          <v-img contain v-if="imagemAnexada" :src="imagemAnexada" alt="imagem do comprovante" width="600" class="pa-0 ma-0"/>
                          <object v-if="arquivoAnexado" width="600" height="600" type="application/pdf" :data="arquivoAnexado"></object>
                          <v-card v-if="!imagemAnexada && !arquivoAnexado" color="grey" width="400" height="400">
                              <v-layout justify-center align-center fill-height>
                                  <div class="title white--text pa-4 text-xs-center">Sem comprovante anexado</div>
                              </v-layout>
                          </v-card>
                      </v-flex>
                  </v-layout>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_cancelamento" width="400">
              <v-card>
                <v-card-text
                  class="text-xs-center headline primary--text"
                >Confirme o cancelamento da fatura para a empresa {{fatura_cancelamento.posto}}</v-card-text>
                <v-card-actions>
                  <v-btn block flat color="grey darken-3" @click="dialog_cancelamento = false">VOLTAR</v-btn>
                  <v-btn block flat color="green" @click="confirmarCancelamento()" >CONFIRMAR</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="mostrando_detalhes" width="550" v-if="mostrando_detalhes">
              <detalhes-faturamento :id_fatura="fatura_selecionada.id" :desconto="fatura_selecionada.desconto_proposta" @recarregar="pegarFaturas()"></detalhes-faturamento>
            </v-dialog>
            <v-dialog v-model="dialogBloquear" width="550" v-if="dialogBloquear">
              <bloqueio-empresa :fatura="fatura_selecionada"  @fechar="dialogBloquear = false"/>
            </v-dialog>
        </v-layout>
        <v-snackbar
          v-model="snackbar.active"
          :color="snackbar.color"
          :multi-line="snackbar.multiLine"
          :timeout="snackbar.timeout"
          :vertical="snackbar.vertical"
        >
          {{ snackbar.text }}
          <v-btn
            flat
            @click="snackbar.active = false"
          >
            Fechar
          </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>

import { faturamentoDao } from '@/api'
import DetalhesFaturamento from '@/components/dialogs/DetalhesFaturamento'
import BloqueioEmpresa from '@/components/dialogs/BloqueioEmpresa'

export default {
  components: {
    DetalhesFaturamento,
    BloqueioEmpresa
  },
  data: () => ({
    faturamentos: [],
    data: new Date(),
    selected_filter: null,
    picker: null,
    dialog_confirmacao: false,
    fatura_selecionada: { id: 0 },
    mostrando_detalhes: false,
    fatura_cancelamento: {},
    dialog_cancelamento: false,
    selected_date: null,
    imagemAnexada: null,
    arquivoAnexado: null,
    visualizarComprovante: false,
    dialogBloquear: false,
    filters: [
      {
        text: 'Todas',
        value: 'todos'
      },
      {
        text: 'Recebidas',
        value: 'recebidos'
      },
      {
        text: 'Pendentes',
        value: 'pendentes'
      }
    ],
    snackbar: {
      active: false,
      color: '',
      multiLine: true,
      timeout: 4000,
      vertical: true,
      text: ''
    }
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    posto () {
      return this.$store.getters.posto
    },
    headers () {
      return this.$store.getters.headers
    },
    filtros () {
      let tempFilters = {}
      switch (this.selected_filter) {
        case 'recebidos':
          tempFilters['fatura_paga'] = true
          break
        case 'pendentes':
          tempFilters['fatura_paga'] = false
          break
        case 'todos':
          break
        default:
          tempFilters['fatura_paga'] = false
          break
      }
      if (this.picker) {
        tempFilters['data_fatura__month'] = this.picker.split('-')[1]
        tempFilters['data_fatura__year'] = this.picker.split('-')[0]
      }

      return tempFilters
    }
  },
  beforeMount () {
    if (this.posto !== undefined && this.posto !== null) {
      this.pegarFaturas()
    }
  },
  watch: {
    posto (val) {
      if (val !== undefined && val !== null) {
        this.pegarFaturas()
      }
    },
    filtros () {
      this.pegarFaturas()
    }
  },
  methods: {
    snackbarSuccess (text) {
      this.snackbar.color = 'info'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    snackbarError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    pegarFaturas () {
      faturamentoDao.pegarFaturas(this.headers, this.posto.cnpj, this.filtros).then(response => {
        if (!response.ok) {
          this.$store.dispatch('setError', 'Não foi possívei pegar faturas')
          return
        }
        return response.json()
      }).then(json => {
        this.faturamentos = json
      }).catch(() => {
        this.$store.dispatch('setError', 'Não foi possívei pegar faturas')
      })
    },
    confirmarPagamento () {
      faturamentoDao.confirmarPagamento(
        this.fatura_selecionada.id,
        this.posto.cnpj,
        {
          fatura_paga: true,
          data_hora_pagamento: `${this.selected_date}T00:00`
        },
        this.headers
      ).then(response => {
        if (!response.ok) {
          this.snackbarError('Não foi possível realizar operação.')
          return
        }
        this.fecharConfirmacao()
        this.pegarFaturas()
        this.snackbarSuccess('Fatura foi marcada com paga.')
      })
    },
    confirmarCancelamento () {
      faturamentoDao.confirmarPagamento(
        this.fatura_cancelamento.id,
        this.posto.cnpj,
        {
          fatura_paga: false,
          data_hora_pagamento: null
        },
        this.headers
      ).then(() => {
        this.dialog_cancelamento = false
        this.pegarFaturas()
      })
    },
    selecionarFatura (fatura) {
      this.fatura_selecionada = fatura
      this.dialog_confirmacao = true
    },
    fecharConfirmacao () {
      this.selected_date = null
      this.dialog_confirmacao = false
    },
    selecionarFaturaCancelamento (fatura) {
      this.fatura_cancelamento = fatura
      this.dialog_cancelamento = true
    },
    visualizarAnexo (faturamento) {
      this.fatura_selecionada = faturamento
      if (faturamento && faturamento.comprovante_pagamento) {
        if (faturamento.comprovante_pagamento.indexOf('png') === -1) {
          this.arquivoAnexado = faturamento.comprovante_pagamento
        } else {
          this.imagemAnexada = faturamento.comprovante_pagamento
        }
      }
      this.visualizarComprovante = true
    },
    limparCampos () {
      this.arquivoAnexado = null
      this.imagemAnexada = null
    },
    fechar () {
      this.visualizarComprovante = false
      this.limparCampos()
    },
    visualizarFatura (fatura) {
      this.fatura_selecionada = fatura
      this.mostrando_detalhes = true
    },
    TelaBloqueio (fatura) {
      this.fatura_selecionada = fatura
      this.dialogBloquear = true
    }
  }
}
</script>
